<p-dialog header="Foreclosure Auction Location Change Log" #tt
    [modal]="true"
    [responsive]="true"
    [(visible)]="showDialog" 
    (onHide)="dialogHide()"
    [contentStyle]="{'width':'1500px','min-height':'320px','max-height':'650px','overflow-y':'auto'}">
    
    <form name="changeLogForm" [formGroup]="changeLogForm" (ngSubmit)="onSubmitChangeLogForm()">
        <div style="display: flex;">
            <div class="formFields">
                <p-listbox #listboxChangedBy [options]="changedBy" 
                      [(ngModel)]="selectedChangedByUsers" 
                      multiple="multiple"  
                      optionLabel="name"
                      [filter]="showChangedbyFilter"
                      formControlName="ChangedBy" 
                      [checkbox]="showChangeByCheckBox"
                      [disabled]="disableChangedCheckBox"
                      styleClass="changeLogListChangedBy">
                    <p-header class="p-list-header">
                        Changed By
                    </p-header>
                </p-listbox>
            </div>
            <div  class="formFields">
                <p-listbox #listboxStates [options]="uniqueClientIds" 
                        [(ngModel)]="selectedClientId" 
                        multiple="multiple"  
                        optionLabel="name"
                        [checkbox]="showUniqueClientIdCheckBox"
                        [disabled]="disableuniqueClientIdCheckBox"
                        [filter]="showUniqueClientIdFilter"
                        formControlName="UniqueClientID"
                        styleClass="changeLogList">
                  <p-header class="p-list-header">
                   Unique Client ID
                  </p-header>
                </p-listbox> 
            </div>
            <div  class="formFields">  
                <p-listbox #listboxTrsustee [options]="loanType" 
                    [(ngModel)]="selectedLoanType" 
                    multiple="multiple" 
                    [checkbox]="showLoanTypeCheckBox"  
                    optionLabel="name"
                    [filter]="showLoanTypeFilter"
                    [disabled]="disableLoanTypeCheckBox"
                    formControlName="LoanType"
                    styleClass="changeLogList">
                    <p-header class="p-list-header">
                      Loan Type
                    </p-header>
                </p-listbox>
            </div>
            <div  class="formFields">  
                <p-listbox #listboxTypeOfSale [options]="typeOfSale" 
                    [(ngModel)]="selectedTypeOfSale" 
                    multiple="multiple" 
                    [checkbox]="showTypeOfSaleCheckBox"  
                    optionLabel="name"
                    [filter]="showTypeOfSaleFilter"
                    [disabled]="disableTypeOfSaleCheckBox"
                    formControlName="TypeOfSale"
                    styleClass="changeLogList">
                    <p-header class="p-list-header">
                      Type Of Sale
                    </p-header>
                </p-listbox>
            </div>
            <div  class="formFields">  
                <p-listbox #listboxFeeType [options]="feeType" 
                    [(ngModel)]="selectedFeeType" 
                    multiple="multiple" 
                    [checkbox]="showFeeTypeCheckBox"  
                    optionLabel="name"
                    [filter]="showFeeTypeFilter"
                    [disabled]="disableFeeTypeCheckBox"
                    formControlName="FeeType"
                    styleClass="changeLogList">
                    <p-header class="p-list-header">
                     Fee Type
                    </p-header>
                </p-listbox>
            </div>
            <div  class="formFields">  
                <p-listbox #listboxFeeType [options]="feeAmount" 
                    [(ngModel)]="selectedFeeAmount" 
                    multiple="multiple" 
                    [checkbox]="showFeeAmountCheckBox"  
                    optionLabel="name"
                    [filter]="showFeeAmountFilter"
                    [disabled]="disableFeeAmountCheckBox"
                    formControlName="FeeAmount"
                    styleClass="changeLogList">
                    <p-header class="p-list-header">
                     Fee Amount
                    </p-header>
                </p-listbox>
            </div>
            <div style="width:22%">
                <div class="date-range-title">Date Range:</div>
                <div style ="display: flex;">
                  <p-calendar [(ngModel)]="minDate"  formControlName="FromDate" [showIcon]="true" class="form-group" 
                    styleClass="treetableDate" >
                  </p-calendar> <div class="calenderSpace">to</div>
                  <p-calendar [(ngModel)]="maxDate" formControlName="ToDate" [showIcon]="true" class="form-group" 
                    styleClass="treetableDate"></p-calendar>
                </div>
                <div class="days-margin-left">
                  <a class="underline" (click)="setDateRange(6)">last 7 days</a>&nbsp;
                  <a class="underline" (click)="setDateRange(29)">Last 30 days</a>&nbsp;
                  <a class="underline" (click)="setDateRange(89)">Last 90 days</a>
                </div>
            </div>
            <div class="form-group" style="margin-top: 13px;">
                <button pButton  type="submit" label="View" [disabled]="!changeLogForm.valid || disableChangeLogForm" class="margin-left-view-button"></button>&nbsp;&nbsp;
                <button pButton  type="button" label="Reset" (click)="resetForm()" class="ui-button-secondary margin-left"></button>
            </div>
        </div>
    </form>
    <p-table #dt [value]="data"
        [columns]="cols"
        autoLayout=true 
        [rows]="10"
        [paginator]="isPaginatorVisible()"
        [totalRecords]="records" 
        [rowsPerPageOptions]="[10,25,50,100]"
        dataKey="AuctionFeesMatrixAuditId" 
        rowExpandMode="multiple"
        [loading]="loading">

        <ng-template pTemplate="caption">
            <div style="margin-top: -16px; float: right; display: flex;" *ngIf="data && data.length >0"> 
                <div style="margin-top: 1.5%;font-size: 0.9em;">
                    {{records}} Records Found
                </div>&nbsp;&nbsp;  
            </div>
        </ng-template>

        <ng-template  pTemplate="header">
            <tr #header *ngIf="formSubmitted">
                <th style="width: 3em"></th>
                <ng-container *ngFor="let col of cols">
                    <th *ngIf="col.showInHeader">
                        {{col.header}}
                    </th>
                </ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading && data && data.length === 0 && formSubmitted">
                <td [attr.colspan]="10" class="center-align">No records found</td> 
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
            <tr>
                <td>
                    <a href="#" [pRowToggler]="rowData" class="changeLogAnchor">
                        <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                    </a>
                </td>
                <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.showInHeader">
                        {{rowData[col.field]}}
                    </td>
                </ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData  let-columns="columns" let-rowIndex="rowIndex">
            <tr>
                <td width="50%" colspan="2">
                  <div class="section-header">Changed Values</div>
                  <div class="section-data">
                      <span class="section-data-label">Loan Type:</span>&nbsp;
                      <span *ngIf="rowData.CurrentIsActive" [ngClass]="(rowData.PreviousLoanType !== null) ? 
                        (rowData.CurrentLoanType != rowData.PreviousLoanType ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                        {{rowData.CurrentLoanType}}
                      </span>
                  </div>
                  <div class="section-data">
                    <span class="section-data-label">Type Of Sale: </span>&nbsp;
                    <span *ngIf="rowData.CurrentIsActive" [ngClass]="(rowData.PreviousTypeOfSale !== null) ? 
                      (rowData.CurrentTypeOfSale != rowData.PreviousTypeOfSale ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.CurrentTypeOfSale}}
                    </span>
                  </div>
                  <div class="section-data" >
                    <span class="section-data-label">Fee Type :</span>&nbsp;
                    <span *ngIf="rowData.CurrentIsActive" [ngClass]="(rowData.PreviousFeeType !== null) ? 
                      (rowData.CurrentFeeType != rowData.PreviousFeeType ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                    {{rowData.CurrentFeeType}}
                    </span>
                  </div>
                  <div class="section-data">
                    <span class="section-data-label">Fee Amount : </span>&nbsp;
                    <span *ngIf="rowData.CurrentIsActive" [ngClass]="(rowData.PreviousFeeAmount !== null) ? 
                      (rowData.CurrentFeeAmount != rowData.PreviousFeeAmount ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.CurrentFeeAmount}}
                    </span>
                  </div>
                </td>
                <td width="50%" colspan="2">  
                  <div class="section-header">Previous Values</div>
                  <div class="section-data">
                      <span class="section-data-label">Loan Type:</span>&nbsp;
                      <span [ngClass]="(rowData.PreviousLoanType !== null) ? 
                        (rowData.CurrentLoanType != rowData.PreviousLoanType ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                        {{rowData.PreviousLoanType == null ? '' : rowData.PreviousLoanType}}
                      </span>
                  </div>
                  <div class="section-data" >
                    <span class="section-data-label">Type Of Sale:</span>&nbsp;
                    <span [ngClass]="(rowData.PreviousTypeOfSale !== null) ? 
                      (rowData.CurrentTypeOfSale != rowData.PreviousTypeOfSale ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.PreviousTypeOfSale == null ? '' : rowData.PreviousTypeOfSale}}
                    </span>                       
                  </div>
                  <div class="section-data">
                    <span class="section-data-label">Fee Type: </span>&nbsp;
                    <span [ngClass]="(rowData.PreviousFeeType !== null) ? 
                      (rowData.CurrentFeeType != rowData.PreviousFeeType ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.PreviousFeeType == null ? '' : rowData.PreviousFeeType}}
                    </span>
                  </div>
                  <div class="section-data">
                    <span class="section-data-label">Fee Amount: </span>&nbsp;
                    <span [ngClass]="(rowData.PreviousFeeAmount !== null) ? 
                      (rowData.CurrentFeeAmount != rowData.PreviousFeeAmount ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.PreviousFeeAmount == null ? '' : rowData.PreviousFeeAmount}}
                    </span>
                  </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
